<template>
  <div
    class="detail"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <BaseInfoForm
            :contractStatus="contractStatus"
            ref="baseInfoFormRef"
            :fetchData="formData"
            :totalAmount="totalAmount"
            @updateSettlementEntityList="getSettlementEntityList"
            @contractValidFrom="contractValidFrom"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            合同信息
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs v-model="tabName" type="card">
            <el-tab-pane label="合同行信息" name="contract">
              <el-collapse v-model="activeContractNames" class="collapse-main-content">
                <el-collapse-item name="1">
                  <template slot="title">
                    <div class="collapse-title-pre">
                      <span></span>
                      仓库信息
                    </div>
                  </template>
                  <div class="collapse-content">
                    <StoreRowTable
                      :contractStatus="contractStatus"
                      ref="storageLinesRef"
                      :fetchTableData="storageList"
                    />
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <div class="collapse-title-pre">
                      <span></span>
                      结算信息
                    </div>
                  </template>
                  <div class="collapse-content">
                    <StatementRowTable
                      :contractStatus="contractStatus"
                      ref="settlementLinesRef"
                      :contractValid="contractValid"
                      :fetchTableData="settlementList"
                      @setAmount="setTotalAmount($event)"
                    />
                  </div>
                </el-collapse-item>
                <el-collapse-item name="3">
                  <template slot="title">
                    <div class="collapse-title-pre">
                      <span></span>
                      结算明细
                    </div>
                  </template>
                  <div class="collapse-content">
                    <SettlementDetailTable
                      ref="settlementDetailRef"
                      :contractStatus="contractStatus"
                      :detail="baseInfoEntityData"
                      :fetchTableData="settlementDetailList"
                    />
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <template v-if="currentStatus !== 'create'">
              <el-tab-pane label="关联合同信息" name="relationContractInfo">
                <RelationContractTable ref="relationContractInfoRef" :fetchTableData="relatedList">
                </RelationContractTable>
              </el-tab-pane>
              <el-tab-pane label="历史执行情况" name="historyExecute">
                <el-collapse v-model="historyExecuteActiveNames" class="collapse-main-content">
                  <el-collapse-item name="1">
                    <template slot="title">
                      <div class="collapse-title-pre">
                        <span></span>
                        收款信息
                      </div>
                    </template>
                    <div class="collapse-content">
                      <HistoryExecuteTable
                        ref="historyExecuteTableRef"
                        :fetchTableData="paymentTotal"
                      />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item name="2">
                    <template slot="title">
                      <div class="collapse-title-pre">
                        <span></span>
                        发票信息
                      </div>
                    </template>
                    <div class="collapse-content">
                      <InvoiceInformationExpandTable
                        ref="invoiceInformationExpandTableRef"
                        :fetchTableData="invoiceTotal"
                      />
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="审批记录" name="approvalRecord">
                <ApprovalRecordTable ref="approvalRecordRef" :fetchTableData="approvalList" />
              </el-tab-pane>
              <el-tab-pane label="变更记录" name="changeRecord" v-if="changeList.length">
                <ChangeRecordTable ref="changeRecordRef" :fetchTableData="changeList" />
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <!-- <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="isShowDownBtn" /> -->
          <IEUploadFileType
            ref="fileTableRef"
            :tableData="attachments || []"
            @upload="handleUpload"
            :isShowDownBtn="isShowDownBtn"
            dictType="SuperviseContractAttachmentType"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 按钮组 -->
    <FooterBtnGroup @btnHandler="btnGroupHandler" :contractStatus="contractStatus" />
    <!-- 关闭合同弹框 -->
    <CloseContractDialog ref="closeContractDialogRef" @refreshTable="closeContractHandler" />
    <!-- 审批或拒绝弹框 -->
    <ApprovalDialog ref="approvalDialogRef" @refreshTable="closeContractHandler" />
  </div>
</template>

<script>
  import BaseInfoForm from './components/BaseInfoForm/index.vue';
  import SettlementDetailTable from './components/SettlementDetailTable/index.vue';
  import StoreRowTable from './components/StoreRowTable/index.vue';
  import StatementRowTable from './components/StatementRowTable/index.vue';
  import FooterBtnGroup from './components/FooterBtnGroup/index.vue';
  import RelationContractTable from './components/RelationContractTable/index.vue';
  import HistoryExecuteTable from './components/HistoryExecuteTable/index.vue';
  import InvoiceInformationExpandTable from './components/InvoiceInformationExpandTable/index.vue';
  import ApprovalRecordTable from './components/ApprovalRecordTable/index.vue';
  import ChangeRecordTable from './components/ChangeRecordTable/index.vue';
  import CloseContractDialog from './components/CloseContractDialog/index.vue';
  import ApprovalDialog from './../SuperviseContractList/components/ApprovalDialog/index.vue';
  import btnGroupMixin from './btnGroupMixin';
  import superviseContractApi from '@/api/park/superviseContract';
  import projectApi from '@/api/park/project';
  export default {
    name: 'detail',
    mixins: [btnGroupMixin],
    data() {
      return {
        activeNames: ['1', '2', '3', '4'],
        historyExecuteActiveNames: ['1', '2'],
        activeContractNames: ['1', '2', '3'],
        currentStatus: 'create',
        tabName: 'contract',
        isLoading: false,
        // 获取数据反填
        settlementList: [],
        storageList: [],
        changeList: [],
        approvalList: [],
        relatedList: [],
        attachments: [],
        paymentTotal: {},
        invoiceTotal: {},
        formData: {},
        contractStatus: '', // 当前合同状态
        changeRowData: null,
        fileTypeList: [], // 附件文件类型
        contractValid: {},
        projectCode: null,
        totalAmount: 0, //传递给表单合同金额
        baseInfoEntityData: {}, // 结算明细中的结算主体数据
        settlementDetailList: [],
      };
    },
    computed: {
      isShowDownBtn() {
        const currentStatus = this.$route.query.status;
        if (['editAgreement', 'renew', 'change', 'create'].includes(currentStatus)) {
          return false;
        } else {
          return ['02', '03', '05', '06'].includes(this.contractStatus);
        }
      },
    },
    mounted() {
      this.projectIntoContract();
      this.currentStatus = this.$route.query?.status;
      this.fileTypeList = this.dictListMap.SuperviseContractAttachmentType; // 文件类型
      const id = this.$route.query?.id;
      if (id) {
        this.initPageData(id);
      }
    },
    methods: {
      getSettlementEntityList(entityObject) {
        this.baseInfoEntityData = entityObject;
      },
      // 接受结算行数据，将合同金额填充到表单
      setTotalAmount(value) {
        console.log('setTotalAmount', value);
        this.totalAmount = value;
      },
      contractValidFrom(dataObj = { contractValidFrom: '', contractValidUntil: '' }) {
        this.contractValid = dataObj;
      },
      // 上传
      handleUpload(attachments) {
        this.attachments = attachments;
      },
      changeCurrentStatus() {
        this.currentStatus = this.$router.query?.status;
      },
      // 初始化数据
      async initPageData(id) {
        this.isLoading = true;
        const { data } = await this.$axios.post(
          `${superviseContractApi.GET_CONTRACT_DETAIL_BY_ID}/${id}`
        );
        this.isLoading = false;
        if (data.code == 0) {
          const {
            settlementList,
            storageList,
            changeList,
            approvalList,
            relatedList,
            attachments,
            paymentTotal,
            invoiceTotal,
            settlementDetailList,
            ...formData
          } = data.data;
          // 复制合同时
          if (this.$route.query.status == 'create') {
            this.storageList = storageList?.map((item) => {
              return {
                ...item,
                id: null,
              };
            });
            this.settlementList = settlementList?.map((item) => {
              return {
                ...item,
                id: null,
              };
            });
            this.formData = { ...formData, id: null, projectName: '', projectNo: '' };
            this.contractValid = {
              contractValidFrom: formData.contractValidFrom,
              contractValidUntil: formData.contractValidUntil,
            };
            // 其他情况获取详情
          } else {
            this.settlementList = settlementList;
            this.storageList = storageList;
            this.changeList = changeList;
            this.approvalList = approvalList;
            this.relatedList = relatedList;
            this.attachments = attachments;
            this.paymentTotal = paymentTotal;
            this.invoiceTotal = invoiceTotal;
            this.settlementDetailList = settlementDetailList;
            this.formData = formData;
            this.contractStatus = formData.contractStatus;
            this.contractValid = {
              contractValidFrom: formData.contractValidFrom,
              contractValidUntil: formData.contractValidUntil,
            };
            this.getSettlementEntityList(formData);
          }
        } else {
          console.error('获取数据失败');
          this.$message.error('获取数据失败');
        }
      },
      closeContractHandler() {
        // 判断当前是否为变更主体的时候
        if (this.changeRowData) {
          // 路由直接跳转
          const path = {
            path: `/park/superviseContract/detail`,
            name: 'detail',
            meta: {
              keepAlive: false,
              title: '监管合同维护',
            },
            query: {
              status: 'create',
              id: this.changeRowData.id,
            },
          };
          this.changeRowData = null;
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          // 关闭当前并且打开到列表
          this.$store.dispatch('tagsView/delView', {
            path: '/park/superviseContract/detail',
            name: 'detail',
            meta: {
              keepAlive: false,
              title: '',
            },
            query: {},
          });
          this.$router.push({ path: '/park/superviseContract/list' });
        }
      },
      // 项目转合同信息带出
      projectIntoContract() {
        this.projectCode = this.$route.query?.projectCode;
        if (this.projectCode) {
          this.getProjectInfo(this.projectCode);
        }
      },
      // 得到项目信息
      async getProjectInfo(val) {
        this.loading = true;
        const { data } = await this.$axios.post(projectApi.DETAIL, {
          projectCode: val,
        });
        this.loading = false;
        if (data.code == 0) {
          let pledgorName;
          let pledgeeName;
          let relatedName;
          let pledgorNo;
          let pledgeeNo;
          let relatedNo;
          let pledgorContactPerson;
          let pledgeeContactPerson;
          let relatedContactPerson;
          let pledgorContactWay;
          let pledgeeContactWay;
          let relatedContactWay;
          let goodsCategory = [];
          let goodsType = [];
          const wmProjectCargos = data.data.wmProjectCargos;
          goodsType = wmProjectCargos.map((item) => {
            return item.cargoType;
          });
          wmProjectCargos.forEach((item) => {
            if (item.cargoCategory) goodsCategory.push(item.cargoCategory);
          });
          console.log(goodsType, '处理后的goodsType');
          console.log(goodsCategory, '处理后的goodsCategory');
          if (data.data.customerTypeOne) {
            if (data.data.customerTypeOne == '03') {
              //出质方
              pledgorName = data.data.customerNameOne;
              pledgorNo = data.data.customerCodeOne;
              pledgorContactPerson = data.data.customerContactPersonOne;
              pledgorContactWay = data.data.customerContactPhoneOne;
            } else if (data.data.customerTypeOne == '05') {
              //质权方
              pledgeeName = data.data.customerNameOne;
              pledgeeNo = data.data.customerCodeOne;
              pledgeeContactPerson = data.data.customerContactPersonOne;
              pledgeeContactWay = data.data.customerContactPhoneOne;
            } else if (data.data.customerTypeOne == '06') {
              //关联方
              relatedName = data.data.customerNameOne;
              relatedNo = data.data.customerCodeOne;
              relatedContactPerson = data.data.customerContactPersonOne;
              relatedContactWay = data.data.customerContactPhoneOne;
            }
          }
          if (data.data.customerTypeTwo) {
            if (data.data.customerTypeTwo == '03') {
              //出质方
              pledgorName = data.data.customerNameTwo;
              pledgorNo = data.data.customerCodeTwo;
              pledgorContactPerson = data.data.customerContactPersonTwo;
              pledgorContactWay = data.data.customerContactPhoneTwo;
            } else if (data.data.customerTypeTwo == '05') {
              //质权方
              pledgeeName = data.data.customerNameTwo;
              pledgeeNo = data.data.customerCodeTwo;
              pledgeeContactPerson = data.data.customerContactPersonTwo;
              pledgeeContactWay = data.data.customerContactPhoneTwo;
            } else if (data.data.customerTypeTwo == '06') {
              //关联方
              relatedName = data.data.customerNameTwo;
              relatedNo = data.data.customerCodeTwo;
              relatedContactPerson = data.data.customerContactPersonTwo;
              relatedContactWay = data.data.customerContactPhoneTwo;
            }
          }
          if (data.data.customerTypeThree) {
            if (data.data.customerTypeThree == '03') {
              //出质方
              pledgorName = data.data.customerNameThree;
              pledgorNo = data.data.customerCodeThree;
              pledgorContactPerson = data.data.customerContactPersonTwo;
              pledgorContactWay = data.data.customerContactPhoneThree;
            } else if (data.data.customerTypeThree == '05') {
              //质权方
              pledgeeName = data.data.customerNameThree;
              pledgeeNo = data.data.customerCodeThree;
              pledgeeContactPerson = data.data.customerContactPersonTwo;
              pledgeeContactWay = data.data.customerContactPhoneThree;
            } else if (data.data.customerTypeThree == '06') {
              //关联方
              relatedName = data.data.customerNameThree;
              relatedNo = data.data.customerCodeThree;
              relatedContactPerson = data.data.customerContactPersonTwo;
              relatedContactWay = data.data.customerContactPhoneThree;
            }
          }
          this.formData = {
            projectNo: data.data.projectCode,
            projectName: data.data.projectName,
            contractNature: data.data.projectNature,
            pledgorName,
            pledgeeName,
            relatedName,
            pledgorNo,
            pledgeeNo,
            relatedNo,
            pledgorContactPerson,
            pledgeeContactPerson,
            relatedContactPerson,
            pledgorContactWay,
            pledgeeContactWay,
            relatedContactWay,
            goodsType: goodsType.toString(),
            goodsCategory: goodsCategory.toString(),
            operatorName: this.userInfo.userName,
            operaterNo: this.userInfo.userCode,
            parkDepartmentName: this.userInfo.departmentName,
            parkDepartmentNo: this.userInfo.departmentCode,
            parkCompanyName: this.userInfo.companyName,
            parkCompanyNo: this.userInfo.companyCode,
            contractType: '01',
            /* goodsType,
            goodsCategory, */
          };
          this.getSettlementEntityList(this.formData);
          console.log(data.data, '根据项目编号查询到的数据');
          console.log(this.formData, '处理后的formData的值');
        } else {
          this.$message.error('查询数据失败！');
        }
      },
    },

    watch: {
      // 监听路由变化
      $route() {
        this.changeCurrentStatus();
      },
    },
    components: {
      BaseInfoForm,
      StoreRowTable,
      StatementRowTable,
      FooterBtnGroup,
      RelationContractTable,
      HistoryExecuteTable,
      InvoiceInformationExpandTable,
      ApprovalRecordTable,
      ChangeRecordTable,
      CloseContractDialog,
      ApprovalDialog,
      SettlementDetailTable,
    },
  };
</script>

<style lang="scss" scoped></style>
